import { type ImageSectionCreate } from '../../../types'

export const createImageData = (): ImageSectionCreate => ({
  data: null,
  type: 'photo',
})
